import { render, staticRenderFns } from "./Vector.vue?vue&type=template&id=028f9a14&scoped=true&"
import script from "./Vector.vue?vue&type=script&lang=js&"
export * from "./Vector.vue?vue&type=script&lang=js&"
import style0 from "./Vector.vue?vue&type=style&index=0&id=028f9a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f9a14",
  null
  
)

export default component.exports